/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum DriverRouteActionType {
  arrived="arrived",
order="order",
on_the_way="on_the_way",
departed="departed",
update_last_seen="update_last_seen",
break_started="break_started",
break_ended="break_ended"
}

/**
* DriverRouteActionType
*/
export const DriverRouteActionTypeEnumType = types.enumeration("DriverRouteActionType", [
        "arrived",
  "order",
  "on_the_way",
  "departed",
  "update_last_seen",
  "break_started",
  "break_ended",
      ])
